import React, { PureComponent } from 'react';
import {
  Wrapper,
  PreTitle,
  Title,
  ContentContainer
} from '../components/ui';

import Image from '../../../containers/assets/peer-feedback-good-luck.png'

class GoodLuck extends PureComponent {
  render() {
    return (
      <Wrapper>
        <PreTitle>All the best!</PreTitle>
        <Title>That’s All For Now!</Title>
        <ContentContainer>
          <img src={Image} alt='' />
        </ContentContainer>
      </Wrapper>
    );
  }

}

export default GoodLuck;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/good-luck.js